import { api } from "../api";

export interface JobTitle {
  id: string;
  tenantId: string;
  name: string;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
  _count?: {
    staff: number;
  };
}

export interface CreateJobTitleDto {
  name: string;
}

export interface UpdateJobTitleDto {
  name?: string;
  isActive?: boolean;
}

export const jobTitlesApi = {
  getAll: async (includeInactive = false): Promise<JobTitle[]> => {
    const response = await api.get("/job-titles", {
      params: { includeInactive },
    });
    return response.data;
  },

  getById: async (id: string): Promise<JobTitle> => {
    const response = await api.get(`/job-titles/${id}`);
    return response.data;
  },

  create: async (data: CreateJobTitleDto): Promise<JobTitle> => {
    const response = await api.post("/job-titles", data);
    return response.data;
  },

  update: async (id: string, data: UpdateJobTitleDto): Promise<JobTitle> => {
    const response = await api.patch(`/job-titles/${id}`, data);
    return response.data;
  },

  delete: async (id: string): Promise<void> => {
    await api.delete(`/job-titles/${id}`);
  },
};
